export const APP_NAME = 'gin9';
export const APP_TAGLINE = 'กินไหน';

export const STREAM_BASE = 'https://live.aegis.aginix.tech/hls';
export const STORAGE_KEY = 'gin9:v1';
export const LEGACY_KEY = 'kmitl-wall:v2';

/** Concurrent decoding tiles (LRU pool cap). Mobile phones handle ~8 @360p. */
export const POOL = { maxDesktop: 14, maxMobile: 8 } as const;

export const SCAN = { concurrency: 5, timeout: 5000, idxMax: 8 } as const;

/** Cameras known-active at build time (all KMITL food courts). */
export const SEEDS = ['CAM-IT-01', 'CAM-PRATEP-01', 'CAM-PRATEP-02', 'CAM-SCI-01', 'CAM-SCI-02'];

/** Thai display label per site code. */
export const SITE_TH: Record<string, string> = {
  IT: 'ไอที', SCI: 'วิทยาศาสตร์', PRATEP: 'อาคารพระเทพฯ', ENG: 'วิศวกรรม', ARCH: 'สถาปัตย์',
  AGRI: 'เกษตร', AGR: 'เกษตร', FOOD: 'อุตฯ อาหาร', FI: 'อุตฯ อาหาร', MED: 'แพทย์', DENT: 'ทันตแพทย์',
  BUS: 'บริหารธุรกิจ', IET: 'ครุศาสตร์อุตฯ', IC: 'วิทยาลัยนานาชาติ', ADMIN: 'สำนักงานอธิการ',
  LIB: 'หอสมุด', NURSE: 'พยาบาล', LA: 'ศิลปศาสตร์', SIIT: 'วิทยาลัยนวัตกรรม', MASSCOMM: 'นิเทศศาสตร์', GATE: 'ประตูทางเข้า',
  CCTV: 'กล้องจราจรรอบสถาบัน',
};

/** Candidate site codes for the scanner. `k:1` = preselected. */
export const SITE_CODES: { c: string; k?: 1 }[] = [
  { c: 'IT', k: 1 }, { c: 'SCI', k: 1 }, { c: 'PRATEP', k: 1 }, { c: 'ENG', k: 1 },
  { c: 'ARCH', k: 1 }, { c: 'AGRI', k: 1 }, { c: 'FOOD', k: 1 },
  { c: 'MED' }, { c: 'DENT' }, { c: 'BUS' }, { c: 'IET' }, { c: 'IC' }, { c: 'ADMIN' }, { c: 'LIB' },
  { c: 'AGR' }, { c: 'FI' }, { c: 'NURSE' }, { c: 'LA' }, { c: 'SIIT' }, { c: 'MASSCOMM' }, { c: 'GATE' },
];

export const SLOT_COUNT = { '2x2': 4, '3x3': 9, '4x4': 16 } as const;

/** Click-to-cycle order for the quality control. */
export const QUALITY_CYCLE = ['360p', '720p', '1080p', 'AUTO'] as const;

export const isMobile = (): boolean => matchMedia('(max-width:860px)').matches;
